import { oz } from '@weft/utils';
import { PasswordSchema } from './password-schema';

export const ResetPasswordSchema = oz.object({
  password: PasswordSchema,
  confirmPassword: PasswordSchema,
}).refine(data => data.password === data.confirmPassword, {
  message: "Passwords don't match",
  path: ['confirmPassword'], 
});

export type ResetPassword = oz.infer<typeof ResetPasswordSchema>;